export default {
  handler: 'relativeUrl',
  data: ({ casinoCategory, lobbySlug }) => `/${lobbySlug}/category/${casinoCategory}`,
};
